module.exports = ".background{\r\n\tdisplay: block;\r\n    background-color: #003061;\r\n}\r\n\r\n"